/**
 * @generated SignedSource<<eebef84e322d65e9a33ff5a107e7941a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type firstGroupIssues_issueTableGrouping$data = {
  readonly fieldId: string | null | undefined;
  readonly " $fragmentType": "firstGroupIssues_issueTableGrouping";
};
export type firstGroupIssues_issueTableGrouping$key = {
  readonly " $data"?: firstGroupIssues_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"firstGroupIssues_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "firstGroupIssues_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "cc627c313216b2c02d5935c9c7dccd74";

export default node;
